<template>
  <div class="content">
  <thankyou></thankyou>
  </div>
</template>
<script>
  import thankyou from '../../components/Step/ThankYou.vue'
  
  export default {
    components: {
      thankyou,
    },
    data () {
      return {
        
      }
    },
    methods:{
    }
  }
</script>


<style>
.table {
    margin-left: 14px;
}
</style>
